/**
 * External
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Components
 */
import LiveBadgeTag from '../LiveBadgeTag/LiveBadgeTag';

/**
 * Styles
 */
import './LiveStationBadge.scss';

function LiveStationBadge(
  {
    startTime, endTime,
  },
) {
  if (startTime && endTime) {
    return (
      <div className="dtv-live-station-badge">
        <LiveBadgeTag startTime={startTime} endTime={endTime} />
      </div>
    );
  }

  return null;
}

LiveStationBadge.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
};

LiveStationBadge.defaultProps = {
  startTime: '',
  endTime: '',
};

export default LiveStationBadge;
